<mat-dialog-content>
  <lemon-dialog-header>
    <div>{{ 'maksut.merkitse-maksetuksi' | translate | async }}</div>
  </lemon-dialog-header>

  <form>
    <!-- <pre>{{tositteenPvm?.errors | json}}</pre> -->
    <mat-form-field style="width: 230px; margin: 0 auto; display: block">
      <mat-label>{{ 'maksut.maksupaivamaara' | translate | async }}</mat-label>
      <input numberDatePicker matInput [formField]="lomake.tositteenPvm" [matDatepicker]="pickerDay" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
      <mat-datepicker-toggle matSuffix [for]="pickerDay"></mat-datepicker-toggle>
      <mat-datepicker #pickerDay></mat-datepicker>
    </mat-form-field>
    @if (lomake.tositteenPvm(); as n) {
      @if (n.dirty() || n.touched()) {
        @if (onkoVirhe(lomake.tositteenPvm, 'required')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerParse')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerMax')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
        }
        @if (onkoVirhe(lomake.tositteenPvm, 'matDatepickerMin')) {
          <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
        }
      }
    }
  </form>

  <button class="secondarybutton" mat-button (click)="kaytaErapaivaa()">{{ 'maksut.kayta-erapaivaa' | translate | async }}</button>
</mat-dialog-content>

<mat-dialog-actions style="margin: 30px; margin-top: 12.5px; justify-content: center">
  <button class="secondarybutton" mat-button mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <button class="primarybutton" mat-button (click)="tallenna()">{{ 'maksut.merkitse' | translate | async }}</button>
</mat-dialog-actions>
